<template>
    <li :class="getClasses()">
        <a href="#" v-on:click="changeToSection()">
            <i class="material-icons">{{ getIcon() }}</i>
            <p>{{ name }}</p>
        </a>
        <slot></slot>
    </li>
</template>

<script>
export default {
    name: 'menuItem',
    data() { return {} },
    props: ['ischild', 'name', 'navtype', 'itemid', 'isactive', 'icon', 'isadmin'],
    methods: {
        getClasses() {
            return { subitem: this.ischild, active: this.isactive, isAdmin: this.isadmin };
        },
        getIcon() {
            return this.icon == null ? 'push_pin' : this.icon;
        },
        changeToSection(){
            this.$emit('onChange', this.navtype, this.name, this.itemid);
        }
    }
}
</script>
